// extracted by mini-css-extract-plugin
export default {"FilesContainer":"PractitionersDetailsModal_FilesContainer__8QgeM","FileItem":"PractitionersDetailsModal_FileItem__4vEe-","Table":"PractitionersDetailsModal_Table__HP4+p"};